import { StudentChangeRequestRootEffects } from './student-change-request-root.effects';
import { StudentChangeRequestReviewEffects } from './student-change-request-review.effects';
import { StudentChangeRequestProcessedDetailsEffects } from './student-change-request-processed-details.effects';

export const studentChangeRequestsFeatureEffects = [
  StudentChangeRequestRootEffects,
  StudentChangeRequestReviewEffects,
  StudentChangeRequestProcessedDetailsEffects,
];
